const API_KEY = import.meta.env.VITE_FIREBASE_API_KEY;
const BASE = `https://identitytoolkit.googleapis.com/v1`;

export async function createAuthUser(email: string): Promise<string> {
    const password = crypto.randomUUID();
    const res = await fetch(`${BASE}/accounts:signUp?key=${API_KEY}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, returnSecureToken: false }),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.error?.message ?? 'Failed to create auth user');
    return data.localId as string;
}

export async function sendPasswordResetEmail(email: string): Promise<void> {
    const res = await fetch(`${BASE}/accounts:sendOobCode?key=${API_KEY}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ requestType: 'PASSWORD_RESET', email }),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.error?.message ?? 'Failed to send password reset email');
}
